import { FC, useMemo } from 'react';
import { Avatar as ChAvatar, AvatarProps, CircularProgress, Box } from '@chakra-ui/react';
import { checkStepStatus, getTodosProgress } from "domains/todo-list/utils";
import { baseRESTUrl } from 'lib/utils';
import { useAppSelector } from 'lib/redux';
import { selectMe } from 'domains/account';

const wrapWithProgress = (children: any, percentage: number) => (
  <CircularProgress
    size={"58px"}
    color={"brand.500"}
    thickness="10px"
    value={percentage}
    position={"relative"}
    zIndex={10}
  >
    <Box position={"absolute"} top={"6px"} left={"6px"} zIndex={0}>
      { children }
    </Box>
  </CircularProgress>
)

const Avatar:FC<any> = ({ user, styles }) => (
  <ChAvatar
    width={"46px"}
    height={"46px"}
    name={`${user.first_name} ${user.last_name}`}
    src={user.has_avatar ? `${baseRESTUrl()}/v1/user/avatar?key=${user.avatarKey}` : null}
    {...styles}
  />
)

export const MeAvatar: FC<AvatarProps & { showProgress?: boolean }> = ({ size = "md", showProgress, ...styles }) => {
  const { user } = useAppSelector(selectMe);

  const percentage: number = useMemo(() => getTodosProgress(checkStepStatus(user)), [user]);

  if (!user) {
    return null;
  }

  return showProgress
    ? wrapWithProgress(<Avatar user={user} styles={styles} />, percentage)
    : <Avatar user={user} styles={styles} />;
}
